<div class="telephone-dialog">
  {{#if callTrackingInitialized }}
    <div class="form definition-list">
      <div class="form-row"><div data-review-breadcrumb="Original Number" class="field"><dt class="field-label"><label data-help="call_tracking.original_number" for="number">Original Number</label></dt>
<dd class="field-content"><input value="{{original_number}}" class="field-input text-field number" type="text" name="number" id="number" /></dd>
<dd class="field-comment"></dd></div><div class="field"><dt class="field-label">&nbsp;</dt><dd class="field-content"><label class="switch switch-form-row">
  <input type="checkbox" name="tracking" {{#if enabled}}checked{{/if}} />
  <div class="slider"></div><span class="switch-label">Enable Call Tracking</span>
</label>
</dd></div></div>

      <p class="error"></p>

      {{#if enabled}}
        <div class="field">
          <dt class="field-label">
            <label for="workflow">Call Tracking Workflow</label>
          </dt>
          <dd class="field-content">
            {{sp_select_tag "workflow" choices=workflowItems selected=workflow_id required=true includeBlank=false}}
          </dd>
        </div>
      {{/if}}
    </div>

    {{#if enabled}}
      {{#if wants_local_number}}
        <sp-alert class="small-icon" type="warning">            <p>You are tracking a toll-free number. Consider <a href="/admin/phone_numbers/{{original_number_id}}/edit" target="_blank">adding a local number</a> to save call costs.</p>
<span slot="prepend"><span class="icon-wrapper"><svg class="icon icon-important "><use xlink:href="/assets/admin/svg_icon_sprite-ed97dbd7.svg#icon-important-color" class="icon__use icon__use--color"></use></svg></span></span></sp-alert>
      {{/if}}

      <sp-alert class="" type="success">          {{#if tracked_number}}
            <p class="lead"><strong>{{original_number}}</strong> will be replaced with <strong>{{tracked_number}}</strong> on this page.</p>
            <p>Calls to <strong>{{tracked_number}}</strong> will be tracked.</p>
          {{else}}
            <p class="lead"><strong>{{original_number}}</strong> will be replaced with a tracked number on this page.</p>
            <p>The tracked number will be assigned when this page is saved.</p>
          {{/if}}
<span slot="prepend"><span class="icon-wrapper"><svg class="icon icon-call-forwarding "><use xlink:href="/assets/admin/svg_icon_sprite-ed97dbd7.svg#icon-call-forwarding-color" class="icon__use icon__use--color"></use></svg></span></span></sp-alert>

      {{#if call_count}}
        <table class="table call-stats">
          <tr>
            <td>
              <span class="title">Active Since</span>
              <p class="stat">
                {{{ icon 'event' }}}
                {{created_date}}
              </p>
            </td>
            <td>
              <span class="title">Call Total</span>
              <p class="stat">
                {{{ icon 'phone' }}}
                {{call_count}}
              </p>
            </td>
            <td>
              <span class="title">Average call time</span>
              <p class="stat">
                {{{ icon 'time' }}}
                {{call_time}}
              </p>
            </td>
          </tr>
        </table>
      {{/if}}
    {{/if}}
  {{else}}
    <div class="form definition-list">
      <div class="form-row"><div data-review-breadcrumb="Original Number" class="field"><dt class="field-label"><label data-help="call_tracking.original_number" for="number">Original Number</label></dt>
<dd class="field-content"><input value="{{original_number}}" class="field-input text-field number" type="text" name="number" id="number" /></dd>
<dd class="field-comment"></dd></div></div>
      <p class="error"></p>
    </div>
  {{/if}}
</div>
